export default "__VITE_ASSET__1ad503d3__"